import { render, staticRenderFns } from "./AppPolitics.vue?vue&type=template&id=4d717846"
import script from "./AppPolitics.vue?vue&type=script&lang=js"
export * from "./AppPolitics.vue?vue&type=script&lang=js"
import style0 from "./AppPolitics.vue?vue&type=style&index=0&id=4d717846&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports